module.exports = __webpack_public_path__ + "img/3d-avatar.8e6a9ffe.png";